<template>
  <el-card shadow="never">
    <router-view v-if="!showTip"></router-view>
  </el-card>
</template>

<script>
export default {
  name: 'Finance',
  computed: {
    showTip() {
      return this.$root.state.facilityData.showTip;
    },
    header() {
      return `${String(this.$root.state.facilityData.code).toUpperCase()}`;
    },
    dashboardPath() {
      return this.$root.state.facility ? 'Facility Dashboard' : 'Dashboard';
    },
  },
  data() {
    return {
      loading: false,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Finance.vue